module.exports = __webpack_public_path__ + "static/01-470fb4d41f10c85d61df9067e94b10f0.png";